export const forgotPassword = {
    "forgot_pwd_title": "نسيت كلمة المرور",
    "forgot_pwd_email": "البريد الإلكتروني",
    "forgot_pwd_error": "خطأ في إرسال البريد الإلكتروني",
    "forgot_pwd_success": "تم إرسال البريد الإلكتروني",
    "forgot_pwd_submit": "استعادة كلمة المرور",
    "reset_pwd_title": "إعادة تعيين كلمة المرور الخاصة بك",
    "reset_pwd_submit": "إعادة تعيين كلمة المرور",
}
